// The dashboards' advisor, as aldoo.com names it: its name and the Aldoo mark.
export const ALDOO_ADVISOR = { name: "Aldoo AI", icon: "/static/p-images/aldoo-small--66x58.webp" }
